import { Box } from '@mui/material';
import Container from "components/Container";
import Carousel from "../Carousel";

const Hero = ({ backgroundUrl, items }) => {
    return (
        <Box
            sx={{
                backgroundImage: `url(${backgroundUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                width: '100vw',
                height: '800px',
            }}
        >
            <Container>
                {items && <Carousel items={items} />}
            </Container>
        </Box>
    );
};

export default Hero;

